import type { ReactNode } from "react";
import "./ui.css";

interface SectionProps {
	title: string;
	level?: 2 | 3;
	/** A line under the title saying what the section holds. */
	subtitle?: ReactNode;
	actions?: ReactNode;
	children: ReactNode;
}

export function Section({
	title,
	level = 3,
	subtitle,
	actions,
	children,
}: SectionProps) {
	const Heading = level === 2 ? "h2" : "h3";
	return (
		<section className="ui-section">
			<div className="ui-section-head">
				{subtitle != null ? (
					<div>
						<Heading className="ui-section-header-title">{title}</Heading>
						<div className="ui-section-subtitle">{subtitle}</div>
					</div>
				) : (
					<Heading className="ui-section-header-title">{title}</Heading>
				)}
				{actions && <div className="ui-section-header-actions">{actions}</div>}
			</div>
			<div className="ui-section-body">{children}</div>
		</section>
	);
}
